import { useQuery } from "@tanstack/react-query";
import { panelGet } from "common/api/sakusas/sakusas_panel";
import { QUERY_KEYS } from "constant/react_query";

export const useSakusasPanelGet = (id: string, searchBy: string = "id") => {
  const { data: panel } = useQuery(
    [QUERY_KEYS.SAKUSAS_PANEL_GET, id, searchBy],
    async () => {
      const result = await panelGet(id, searchBy);
      return result;
    },
    { staleTime: Infinity }
  );
  const result = typeof panel !== "undefined" && panel !== "" ? panel : null;
  return result;
};
